
import React, { useEffect, useRef, useState } from "react";
import Home from "./home/Home.js";
import View from "./view/view.js";
import Manage from "./manage/Manage.js";
import Intro from "./intro/intro.js";
import Taxes from "./taxes/taxes.js";
import Maintenance from "./maintainence/maintainence.js";
import Franchise from "./franchise/franchise.js";
import { Box, Button } from "@mui/material";
import { useThemeContext } from "../../../Context/ThemeContext.js";
import { DARKCOLORS, LIGHTCOLORS } from "../../../Utils/constants.js";
import { useTranslation } from "react-i18next";
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import { useNavigate } from 'react-router-dom';

function Documentation() {
  const { mode } = useThemeContext();
  const { t } = useTranslation();
  const navigate = useNavigate();

  const containerBG = mode === "dark" ? DARKCOLORS.BackgroundMenu : LIGHTCOLORS.BackgroundMenu;
  const btnBG = mode === "dark" ? DARKCOLORS.GreyScale10 : LIGHTCOLORS.GreyScale10;
  const textColor = mode === 'dark' ? DARKCOLORS.GreyScale60 : LIGHTCOLORS.DisabledLightBackground;
  const backgroundCard = mode === 'dark' ? DARKCOLORS.BackgroundCard : LIGHTCOLORS.BackgroundCard;
  const slidercolor = mode === 'dark' ? DARKCOLORS.Primary500 : LIGHTCOLORS.Primary500;


  const navRef = useRef(null); // Reference to the navigation container
  const [activeIndex, setActiveIndex] = useState(0);
  const [dotPosition, setDotPosition] = useState(0);
  const [dotWidth, setDotWidth] = useState(0);

  const handleClick = (index) => {
    setActiveIndex(index);
    updateDotPosition(index);
  };

  const updateDotPosition = (index) => {
    const items = document.querySelectorAll(".doc-item");
    if (items[index] && navRef.current) {
      const itemRect = items[index].getBoundingClientRect();
      const containerRect = navRef.current.getBoundingClientRect();

      const newDotPosition = itemRect.left - containerRect.left + itemRect.width / 2;
      setDotPosition(newDotPosition);
      setDotWidth(itemRect.width - 10);
    }
  };

  useEffect(() => {
    updateDotPosition(activeIndex);

    const handleResize = () => {
      updateDotPosition(activeIndex);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [activeIndex]);

  // **Dynamically Render Content Based on Selection**
  const renderContent = () => {
    if (activeIndex === null) return null; // No content initially
    switch (activeIndex) {
      case 0:
        return <Intro />;
      case 1:
        return <Home />;
      case 2:
        return <View />;
      case 3:
        return <Manage />;
      case 4:
        return <Taxes />;
      case 5:
        return <Maintenance />;
      case 6:
        return <Franchise />;
      default:
        return <Home />;
    }
  };
  return (
    <div
      className="doc-container"
      style={{
        backgroundColor: containerBG,
        borderRadius: "10px",
        margin: "20px 10px",
        width: "100%",
      }}
    >
      <Box className="back-btn-sec" style={{ display: 'flex', position: 'relative', left: '-10px', alignItems: 'end', }}>
        <Button className="back-btn"
          onClick={() => navigate("/help")}

          sx={{
            width: 38,
            height: 38,
            padding: 0,

            borderRadius: "50%",
            bgcolor: btnBG,

            minWidth: "unset",  // Prevents default min-width in MUI
            // "&:hover": { bgcolor: backgroundCard}  // Adds hover effect
          }}
        >
          <KeyboardBackspaceIcon sx={{ color: slidercolor }} />
        </Button>
        <h2 className="back-btn-text" style={{ marginBottom: '0', marginLeft: '10px' }}>Back</h2>

      </Box>


      {/* this BOx class css in homeCSS */}
      <Box className="doc-menu-sec"
        ref={navRef}
        sx={{
          width: "50%",
          height: "100px",
          position: "relative",
          overflow: "hidden",
          display: "flex",
          alignItems: "center",
          marginBottom: "20px",
        }}
      >
        <Box className="doc-menu-container"
          sx={{
            display: "flex",
            justifyContent: "space-around",
            flexGrow: 1,
            position: "relative",
            transition: "transform 0.3s ease",
          }}
        >
          {[
            { key: "intro", label: t("sidebar.intro") },
            { key: "home", label: t("sidebar.home") },
            { key: "view", label: t("sidebar.view") },
            { key: "manage", label: t("sidebar.manage") },
            { key: "taxes", label: t("sidebar.taxes") },
            { key: "maintenance", label: t("sidebar.maintenance") },
            { key: "franchise", label: t("sidebar.franchise") },
          ].map((item, index) => (
            <Box
              key={index}
              className="doc-item"
              onClick={() => handleClick(index)}
              sx={{
                transition: "transform 0.3s ease",
                transform: activeIndex === index ? "translatey(-13px)" : "translatey(0px)",
                textAlign: "center",
              }}
            >
              <p className="menu-item"
                style={{
                  cursor: "pointer",
                  color: activeIndex === index ? slidercolor : textColor,
                  transform: activeIndex === index ? "scale(1.2)" : "scale(1)",
                  fontWeight: activeIndex === index ? "700" : "500",
                  transition: "color 0.3s ease",
                }}
              >
                {item.label}
              </p>
            </Box>
          ))}
        </Box>

        <span
          style={{
            position: "absolute",
            bottom: "25px",
            left: `${dotPosition}px`,
            transform: "translateX(-50%)",
            borderRadius: "5px",
            backgroundColor: slidercolor,
            width: `6px`,
            height: "6px",
            transition: "left 0.3s ease, width 0.3s ease",
          }}
        />
      </Box>

      {/* Dynamic Content Based on Click */}
      <Box>{renderContent()}</Box>
    </div>
  );
}

export default Documentation;
